// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"42":"ea38aa42109cefeb","797":"2e6dc5aa4080f65a"}[chunkId] + ".css";
};